import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LazyLoad from 'react-lazy-load';
import { CopyrightDate } from "@procter-gamble/copyright-date";
import { getHeading } from '../../../utils/uiHelper';
import { List, ListItem } from '../../Generic/List';
import Typography from '../../Generic/Typography';
import Divider from '../../Generic/Divider';
import { Button } from '../../Generic/Button';
import AccordianTab from '../Accordian';
import footerStyles from './Footer-tw-styles';
import { getCdnImage as getImageUrl } from '../../../utils/ImageManager';
import i18nMessages from '../../../constants/messages/pt-BR';
import { locales } from '../../../constants/configuration';
import { COUNTRY_CODES, fetchCountryPrivacyData  } from "@procter-gamble/country-privacy-data";

export default class Footer extends Component {
  constructor(props) {
    super(props)
    const countryCode = COUNTRY_CODES.BR_PT;
    this.state = {
        privacyLink: '',
        accessibilityLabel: '',
        accessibilityLink: ''
    }
}

  componentDidMount() {
    this.fetchPrivacyLink();
  }

  async fetchPrivacyLink() {
    const defaultCountry = locales[0]
    const countryCode = String(defaultCountry).split('-')[1].toUpperCase()
    const lang = String(defaultCountry).split('-')[0]
    await fetchCountryPrivacyData(`${countryCode}_${lang}`, "prod")
    .then((data) => {
           this.setState({ privacyLink: data.newPrivacyLink, accessibilityLink: data.accessibilityLink, accessibilityLabel: data.accessibilityLabel });
        })
        .catch((error) => console.error('Error fetch', error))
  }

  render() {
    const { footerData, locale } = this.props;
    const bradBar = require(`../../../data/${locale}/brandbar`).default;
    const ImagelistItem =
      bradBar.links &&
      bradBar.links.map((item, i) => {
        let brandName = '';
        if (item.image.altText == 'P&G') {
          brandName = 'Logo Procter & gamble';
        }
        if (item.image.altText == 'Head&Shoulders') {
          brandName = 'Logo Head & shoulders';
        }
        if (item.image.altText == 'Herbal Essences') {
          brandName = 'Logo Herbal Essences';
        }
        return (
          <>
            <div
              className={classNames(footerStyles.brandbar.imageList)}
              key={i}
            >
              <LazyLoad offset={100}>
                <>
                  <a
                    data-pgaction-redirection="0"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="event_outbound_link"
                    aria-label={brandName}
                  >
                    <img
                      className={classNames(footerStyles.brandbar.imageStyle)}
                      src={item.image.resolutions.src}
                      alt={item.image.altText}
                    />
                  </a>
                </>
              </LazyLoad>
            </div>
          </>
        );
      });
    return (
      <footer
        id="footer"
        className={classNames(footerStyles.footer)}
        role="contentinfo"
      >
        <div className={classNames(footerStyles.footerLinks)}>
          {footerData &&
            footerData.footerNavCollection &&
            footerData.footerNavCollection.items.map(item => {
              switch (item.__typename) {
                case i18nMessages.HeadingTypes:
                  return getHeading(item);
                default:
                  return null;
              }
            })}
        </div>
        <LazyLoad offset={100}>
          <>
            <div className={footerStyles.footerMainParent}>
              <div className={footerStyles.footerMenuOne}>
                <div className={footerStyles.footerNavDiv}>
                  {footerData &&
                    footerData.footerLinksCollection &&
                    footerData.footerLinksCollection.items[0] &&
                    footerData.footerLinksCollection.items[0]
                      .sectionContentCollection &&
                    footerData.footerLinksCollection.items[0]
                      .sectionContentCollection.items[0] && (
                      <AccordianTab
                        data={
                          footerData.footerLinksCollection.items[0]
                            .sectionContentCollection.items[0]
                        }
                      />
                    )}
                </div>
                <div className={footerStyles.footerLinksCollection}>
                  <ul>
                    {footerData &&
                      footerData.footerLinksCollection &&
                      footerData.footerLinksCollection.items.map(content => {
                        const isPrivacyLink = content.linkText === i18nMessages.footerPrivacy;
                        switch (content.__typename) {
                          case i18nMessages.LinkButton:
                            return (
                              <>
                                <li>
                                  <Button
                                    href={(content.linkText === i18nMessages.footerPrivacy) ? this.state.privacyLink : content.link}
                                    key={content.id}
                                    area-label={content.tooltip}
                                    title={content.tooltip}
                                    target={content.target}
                                    className={classNames(content.gaEventClass)}
                                    data-action-detail={content.gaEventLabel}
                                  >
                                    {content.linkText}
                                  </Button>
                                </li>
                                {isPrivacyLink && this.state.accessibilityLink && (
                                  <li>
                                    <Button
                                      href={this.state.accessibilityLink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="event_outbound_link"
                                      data-action-detail={this.state.accessibilityLabel}
                                    >
                                      {this.state.accessibilityLabel}
                                    </Button>
                                  </li>
                                )}
                              </>
                            );
                          case 'ImageButton':
                            return (
                              <li>
                                <div
                                  className={classNames(
                                    footerStyles.brandbar.imgButton
                                  )}
                                >
                                  <Button
                                    href={content.link}
                                    key={content.id}
                                    aria-label="Política de proteção de dados do consumidor"
                                    title={content.tooltip}
                                    target={content.target}
                                    className={classNames(content.gaEventClass)}
                                    data-action-detail={content.gaEventLabel}
                                  >
                                    {i18nMessages.adchoices}
                                  </Button>
                                  <img
                                    src={getImageUrl(
                                      content.image && content.image.url
                                    )}
                                    alt="Logo - Política de proteção de dados do consumidor"
                                    className={classNames(
                                      footerStyles.brandbar.imgButtonImg
                                    )}
                                  />
                                </div>
                              </li>
                            );
                          default:
                            return null;
                        }
                      })}
                  </ul>
                </div>
              </div>
              <div className={classNames(footerStyles.subFooterlinksDesktop)}>
                <div className="footer2">
                  {footerData &&
                    footerData.socialConnect &&
                    footerData.socialConnect.linksCollection.items.map(
                      (item, i) => {
                        return (
                          <div
                            key={i}
                            className={footerStyles.brandbar.footer1}
                          >
                            <Button
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={item.gaEventClass}
                              data-action-detail={item.gaEventLabel}
                            >
                              <img
                                src={getImageUrl(item.image && item.image.url)}
                                alt={item.altText}
                              />
                            </Button>
                          </div>
                        );
                      }
                    )}
                </div>
                <br />
              </div>
            </div>
          </>
        </LazyLoad>
        <div className={classNames(footerStyles.brandbar.brandTextStyle)}>
          <div className={footerStyles.footerBrand}>
            <Typography
              component="span"
              className={classNames(footerStyles.brandbar.brandText)}
            >
              {bradBar.text}
            </Typography>
            <Divider
              className={classNames(footerStyles.brandbar.brandTextDivider)}
            />
            <div className={classNames(footerStyles.brandbar.imageListItem)}>
              {ImagelistItem}
            </div>
          </div>
          <div className={classNames(footerStyles.subFooterlinksMobile)}>
            <div className="footer2">
              {footerData &&
                footerData.socialConnect &&
                footerData.socialConnect.linksCollection.items.map(
                  (item, i) => {
                    return item?.link || item.image ? (
                      <LazyLoad offset={100}>
                        <>
                          <div
                            key={i}
                            className={footerStyles.brandbar.footer1}
                          >
                            <Button
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={item.gaEventClass}
                              data-action-detail={item.gaEventLabel}
                            >
                              <img
                                src={getImageUrl(item.image && item.image.url)}
                                alt={item.altText}
                              />
                            </Button>
                          </div>
                        </>
                      </LazyLoad>
                    ) : (
                      <div key={i}>
                        <Button
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={item.gaEventClass}
                          data-action-detail={item.gaEventLabel}
                        >
                          <img
                            src={getImageUrl(item.image && item.image.url)}
                            alt={item.altText}
                          />
                        </Button>
                      </div>
                    );
                  }
                )}
            </div>
            <br />
          </div>
          <div className={footerStyles.footerCopyRiteDiv}>
            <CopyrightDate />
          </div>
        </div>
      </footer>
    );
  }
}
Footer.propTypes = {
  footerData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.any, PropTypes.object])
  ),
  locale: PropTypes.string,
};

Footer.defaultProps = {
  footerData: {},
  locale: 'pt-BR',
};